var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAstronautMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 280,
    viewBox: "0 0 264 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3997 46.84C61.3497 49.94 66.8998 52.53 73.7998 52.64C80.6898 52.75 86.3198 50.32 86.3698 47.23C86.4198 44.13 80.8697 41.54 73.9697 41.43C67.0697 41.32 61.4397 43.75 61.3997 46.84Z",
    fill: "url(#paint0_radial_26_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.836 48.3695C125.226 32.0488 106.78 18.3698 83.6353 17.8164C60.4905 17.2631 41.4116 30.045 41.0214 46.3657C40.6312 62.6863 59.0775 76.3654 82.2224 76.9187C105.367 77.472 124.446 64.6901 124.836 48.3695Z",
    fill: "#A67C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.536 48.3623C124.924 32.1631 106.609 18.5857 83.6301 18.0364C60.6509 17.487 41.7086 30.1737 41.3213 46.3728C40.9341 62.572 59.2484 76.1494 82.2276 76.6988C105.207 77.2481 124.149 64.5615 124.536 48.3623Z",
    fill: "#000001"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6196 46.38C41.2396 62.46 59.4196 75.94 82.2296 76.49C105.04 77.03 123.85 64.44 124.23 48.35C124.61 32.27 106.43 18.79 83.6196 18.24C60.8096 17.7 42.0096 30.3 41.6196 46.38Z",
    fill: "#010101"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.92 46.39C41.54 62.36 59.59 75.74 82.24 76.28C104.89 76.82 123.56 64.32 123.94 48.35C124.32 32.38 106.27 19 83.62 18.46C60.97 17.91 42.3 30.42 41.92 46.39Z",
    fill: "#010102"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.629 48.3322C124.006 32.4864 106.086 19.2069 83.6042 18.6717C61.1219 18.1364 42.5906 30.5481 42.2133 46.3939C41.8361 62.2397 59.7558 75.5192 82.2381 76.0544C104.72 76.5897 123.252 64.178 123.629 48.3322Z",
    fill: "#010103"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.319 48.325C123.694 32.5951 105.91 19.413 83.5992 18.8818C61.2881 18.3506 42.8978 30.6716 42.5233 46.4015C42.1488 62.1314 59.932 75.3135 82.2431 75.8447C104.554 76.3759 122.945 64.0549 123.319 48.325Z",
    fill: "#010204"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.019 48.3177C123.391 32.7038 105.739 19.6188 83.594 19.0916C61.4485 18.5644 43.1947 30.7946 42.823 46.4085C42.4512 62.0224 60.1024 75.1074 82.2479 75.6346C104.393 76.1619 122.647 63.9317 123.019 48.3177Z",
    fill: "#020205"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1298 46.41C42.7598 61.91 60.2798 74.89 82.2598 75.42C104.24 75.94 122.36 63.81 122.73 48.31C123.1 32.81 105.58 19.83 83.5998 19.3C61.6198 18.78 43.4998 30.92 43.1298 46.41Z",
    fill: "#020206"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4296 46.42C43.0596 61.8 60.4496 74.69 82.2696 75.21C104.08 75.73 122.07 63.68 122.43 48.31C122.8 32.93 105.41 20.04 83.5996 19.52C61.7796 19 43.7996 31.04 43.4296 46.42Z",
    fill: "#020306"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7297 46.43C43.3697 61.69 60.6197 74.48 82.2697 75C103.92 75.52 121.76 63.56 122.13 48.3C122.49 33.04 105.24 20.25 83.5897 19.73C61.9397 19.21 44.0997 31.17 43.7297 46.43Z",
    fill: "#030307"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.03 46.44C43.67 61.58 60.79 74.28 82.27 74.79C103.75 75.3 121.46 63.44 121.82 48.3C122.18 33.16 105.06 20.46 83.58 19.95C62.1 19.43 44.4 31.29 44.03 46.44Z",
    fill: "#030308"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.528 48.2904C121.887 33.2618 104.897 20.6655 83.5797 20.1558C62.2624 19.6462 44.69 31.4162 44.3307 46.4449C43.9714 61.4736 60.9613 74.0699 82.2786 74.5795C103.596 75.0891 121.168 63.3191 121.528 48.2904Z",
    fill: "#030409"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.217 48.2828C121.574 33.3756 104.72 20.8811 83.5742 20.3756C62.4281 19.87 44.9968 31.5449 44.6404 46.4521C44.284 61.3593 61.1375 73.8538 82.2836 74.3594C103.43 74.8649 120.861 63.1901 121.217 48.2828Z",
    fill: "#04040A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.94 46.46C44.59 61.25 61.31 73.65 82.29 74.15C103.27 74.65 120.57 63.07 120.92 48.27C121.27 33.48 104.55 21.08 83.57 20.58C62.59 20.08 45.29 31.67 44.94 46.46Z",
    fill: "#04040B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2398 46.47C44.8898 61.14 61.4798 73.44 82.2998 73.94C103.12 74.44 120.27 62.94 120.62 48.27C120.97 33.6 104.38 21.3 83.5598 20.8C62.7498 20.3 45.5898 31.79 45.2398 46.47Z",
    fill: "#05050C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5397 46.47C45.1897 61.03 61.6497 73.23 82.2997 73.72C102.95 74.21 119.97 62.81 120.32 48.25C120.67 33.69 104.21 21.49 83.5597 21C62.9097 20.51 45.8897 31.91 45.5397 46.47Z",
    fill: "#05050D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8397 46.48C45.4997 60.92 61.8197 73.02 82.3097 73.51C102.79 74 119.68 62.69 120.02 48.25C120.36 33.81 104.04 21.71 83.5597 21.22C63.0697 20.73 46.1897 32.04 45.8397 46.48Z",
    fill: "#05050E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M119.71 48.2389C120.051 33.9169 103.856 21.9145 83.5384 21.4308C63.2204 20.9471 46.473 32.1652 46.132 46.4872C45.7911 60.8092 61.9856 72.8115 82.3036 73.2952C102.622 73.779 119.369 62.5608 119.71 48.2389Z",
    fill: "#06060E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M119.4 48.2316C119.738 34.0256 103.68 22.1205 83.5334 21.6408C63.3866 21.1612 46.7802 32.2886 46.442 46.4947C46.1038 60.7007 62.1618 72.6058 82.3086 73.0854C102.455 73.565 119.062 62.4376 119.4 48.2316Z",
    fill: "#06060F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M119.1 48.2242C119.435 34.1342 103.509 22.3263 83.5282 21.8506C63.547 21.3749 47.0771 32.4115 46.7417 46.5016C46.4062 60.5917 62.3322 72.3996 82.3134 72.8753C102.295 73.351 118.765 62.3143 119.1 48.2242Z",
    fill: "#060710"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.05 46.51C46.72 60.48 62.51 72.19 82.33 72.66C102.15 73.13 118.48 62.19 118.81 48.22C119.14 34.25 103.35 22.54 83.53 22.07C63.72 21.6 47.38 32.54 47.05 46.51Z",
    fill: "#070711"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M118.508 48.2182C118.839 34.3655 103.179 22.7549 83.5286 22.2851C63.8787 21.8153 47.6808 32.6643 47.3497 46.517C47.0185 60.3696 62.6794 71.9803 82.3293 72.45C101.979 72.9198 118.177 62.0708 118.508 48.2182Z",
    fill: "#070712"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M118.208 48.2109C118.537 34.4742 103.008 22.9608 83.5234 22.4949C64.0391 22.0291 47.9777 32.7873 47.6493 46.524C47.3209 60.2608 62.8498 71.7742 82.3341 72.24C101.818 72.7058 117.88 61.9476 118.208 48.2109Z",
    fill: "#070813"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9497 46.53C47.6297 60.15 63.0197 71.56 82.3397 72.02C101.66 72.48 117.58 61.81 117.9 48.2C118.22 34.58 102.83 23.17 83.5097 22.71C64.1997 22.25 48.2797 32.91 47.9497 46.53Z",
    fill: "#080814"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2598 46.54C47.9398 60.04 63.1998 71.36 82.3498 71.81C101.5 72.27 117.29 61.69 117.61 48.19C117.93 34.69 102.67 23.37 83.5198 22.92C64.3598 22.46 48.5798 33.04 48.2598 46.54Z",
    fill: "#080815"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M117.299 48.1894C117.619 34.806 102.49 23.5887 83.5083 23.1349C64.5265 22.6811 48.8793 33.1626 48.5593 46.546C48.2394 59.9294 63.3678 71.1466 82.3497 71.6004C101.332 72.0542 116.979 61.5727 117.299 48.1894Z",
    fill: "#090916"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M116.991 48.1741C117.307 34.9067 102.309 23.7882 83.4929 23.3402C64.6767 22.8923 49.1671 33.2845 48.8512 46.5519C48.5354 59.8193 63.5329 70.9379 82.3491 71.3858C101.165 71.8338 116.675 61.4415 116.991 48.1741Z",
    fill: "#090917"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M49.16 46.56C48.85 59.71 63.71 70.73 82.36 71.17C101.01 71.61 116.38 61.32 116.7 48.17C117.01 35.02 102.15 24 83.5 23.56C64.85 23.11 49.47 33.41 49.16 46.56Z",
    fill: "#090A18"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4599 46.57C49.1499 59.6 63.8799 70.52 82.3699 70.96C100.85 71.4 116.09 61.19 116.4 48.16C116.71 35.13 101.98 24.21 83.4899 23.77C65.0099 23.33 49.7699 33.53 49.4599 46.57Z",
    fill: "#0A0A19"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M116.091 48.1526C116.399 35.2386 101.797 24.4161 83.4777 23.98C65.1584 23.5438 50.0585 33.6592 49.751 46.5733C49.4436 59.4873 64.0451 70.3098 82.3644 70.7459C100.684 71.1821 115.784 61.0667 116.091 48.1526Z",
    fill: "#0A0A1A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0601 46.58C49.7501 59.38 64.2201 70.1 82.3701 70.53C100.52 70.96 115.48 60.94 115.79 48.14C116.1 35.34 101.63 24.62 83.4801 24.19C65.3301 23.76 50.3701 33.78 50.0601 46.58Z",
    fill: "#0A0B1B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M115.481 48.1381C115.783 35.4614 101.45 24.8379 83.4676 24.4098C65.4851 23.9817 50.6627 33.9111 50.3609 46.5878C50.0591 59.2644 64.3922 69.8879 82.3747 70.316C100.357 70.7442 115.18 60.8148 115.481 48.1381Z",
    fill: "#0B0B1C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6697 46.59C50.3697 59.15 64.5697 69.68 82.3897 70.1C100.21 70.53 114.9 60.69 115.2 48.12C115.5 35.56 101.3 25.03 83.4797 24.61C65.6497 24.19 50.9697 34.03 50.6697 46.59Z",
    fill: "#0B0C1D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M50.97 46.6C50.67 59.04 64.74 69.47 82.39 69.89C100.04 70.31 114.59 60.56 114.89 48.12C115.19 35.68 101.12 25.25 83.47 24.83C65.82 24.41 51.27 34.16 50.97 46.6Z",
    fill: "#0B0C1E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2701 46.61C50.9801 58.94 64.9101 69.27 82.4001 69.68C99.8801 70.1 114.3 60.44 114.59 48.12C114.88 35.79 100.95 25.46 83.4601 25.05C65.9801 24.63 51.5601 34.28 51.2701 46.61Z",
    fill: "#0C0C1F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5699 46.62C51.2799 58.83 65.0799 69.06 82.3999 69.47C99.7199 69.88 113.99 60.32 114.29 48.11C114.58 35.9 100.78 25.67 83.4599 25.25C66.1399 24.84 51.8599 34.41 51.5699 46.62Z",
    fill: "#0C0D1F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8698 46.62C51.5798 58.71 65.2498 68.85 82.3998 69.26C99.5498 69.67 113.69 60.2 113.98 48.11C114.27 36.02 100.6 25.88 83.4498 25.47C66.2998 25.06 52.1598 34.53 51.8698 46.62Z",
    fill: "#0D0D20"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M113.68 48.1028C113.966 36.1274 100.431 26.0902 83.4477 25.6842C66.4645 25.2782 52.4648 34.657 52.1785 46.6325C51.8922 58.608 65.4277 68.6451 82.4109 69.0512C99.3941 69.4572 113.394 60.0783 113.68 48.1028Z",
    fill: "#0D0D21"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4799 46.64C52.1999 58.5 65.5999 68.43 82.4199 68.84C99.2399 69.24 113.1 59.95 113.39 48.1C113.67 36.24 100.27 26.31 83.4499 25.9C66.6199 25.49 52.7599 34.78 52.4799 46.64Z",
    fill: "#0D0E22"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7797 46.64C52.4997 58.38 65.7697 68.22 82.4197 68.62C99.0697 69.02 112.8 59.82 113.08 48.08C113.36 36.34 100.09 26.5 83.4397 26.1C66.7797 25.71 53.0597 34.9 52.7797 46.64Z",
    fill: "#0E0E23"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0796 46.65C52.7996 58.27 65.9396 68.01 82.4296 68.41C98.9196 68.8 112.51 59.7 112.78 48.08C113.05 36.46 99.9196 26.71 83.4296 26.32C66.9496 25.93 53.3596 35.03 53.0796 46.65Z",
    fill: "#0E0F24"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3796 46.66C53.1096 58.16 66.1096 67.81 82.4296 68.2C98.7496 68.59 112.2 59.58 112.48 48.07C112.75 36.57 99.7496 26.92 83.4296 26.53C67.1096 26.14 53.6596 35.15 53.3796 46.66Z",
    fill: "#0F0F25"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M53.68 46.67C53.41 58.06 66.28 67.6 82.44 67.99C98.59 68.38 111.91 59.46 112.18 48.07C112.45 36.68 99.58 27.14 83.42 26.75C67.26 26.36 53.95 35.28 53.68 46.67Z",
    fill: "#0F0F26"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9798 46.67C53.7098 57.94 66.4498 67.39 82.4398 67.77C98.4298 68.15 111.6 59.32 111.87 48.05C112.14 36.78 99.3998 27.33 83.4098 26.95C67.4298 26.58 54.2498 35.4 53.9798 46.67Z",
    fill: "#0F1027"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2899 46.68C54.0199 57.83 66.6299 67.18 82.4499 67.56C98.2699 67.94 111.31 59.2 111.58 48.05C111.85 36.9 99.2399 27.55 83.4199 27.17C67.5899 26.79 54.5499 35.53 54.2899 46.68Z",
    fill: "#101028"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M111.27 48.045C111.534 37.0082 99.059 27.7577 83.4064 27.3835C67.7538 27.0093 54.851 35.653 54.5871 46.6899C54.3233 57.7268 66.7983 66.9773 82.4509 67.3515C98.1034 67.7257 111.006 59.0819 111.27 48.045Z",
    fill: "#101129"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8898 46.7C54.6298 57.62 66.9698 66.77 82.4598 67.14C97.9498 67.51 110.71 58.96 110.97 48.04C111.23 37.12 98.8898 27.97 83.3998 27.6C67.9198 27.23 55.1498 35.78 54.8898 46.7Z",
    fill: "#10112A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1896 46.7C54.9296 57.5 67.1396 66.55 82.4596 66.92C97.7796 67.29 110.41 58.83 110.67 48.03C110.93 37.23 98.7196 28.17 83.3996 27.81C68.0796 27.44 55.4496 35.9 55.1896 46.7Z",
    fill: "#11112B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M110.363 48.0165C110.617 37.333 98.5375 28.3798 83.3819 28.019C68.2262 27.6582 55.7339 36.0264 55.4796 46.7099C55.2252 57.3934 67.3051 66.3466 82.4608 66.7074C97.6165 67.0682 110.109 58.7 110.363 48.0165Z",
    fill: "#11122C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M110.061 48.016C110.313 37.4485 98.3706 28.5913 83.3861 28.2331C68.4016 27.8749 56.0494 36.1512 55.7968 46.7187C55.5442 57.2863 67.4867 66.1434 82.4712 66.5016C97.4557 66.8599 109.808 58.5836 110.061 48.016Z",
    fill: "#12122D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M109.761 48.0091C110.011 37.563 98.2002 28.8076 83.3813 28.4533C68.5625 28.0991 56.3469 36.2801 56.0972 46.7262C55.8475 57.1723 67.6581 65.9277 82.477 66.282C97.2958 66.6363 109.511 58.4552 109.761 48.0091Z",
    fill: "#12132E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M109.453 47.9946C109.699 37.6644 98.0197 29.0074 83.3665 28.6585C68.7132 28.3097 56.6351 36.4011 56.3891 46.7313C56.1432 57.0614 67.8226 65.7185 82.4759 66.0673C97.1291 66.4162 109.207 58.3247 109.453 47.9946Z",
    fill: "#12132F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6998 46.74C56.4498 56.95 67.9998 65.51 82.4898 65.86C96.9798 66.21 108.92 58.21 109.16 47.99C109.4 37.78 97.8598 29.22 83.3698 28.87C68.8798 28.53 56.9398 36.52 56.6998 46.74Z",
    fill: "#131330"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9998 46.75C56.7598 56.85 68.1698 65.31 82.4898 65.65C96.8098 65.99 108.62 58.08 108.86 47.99C109.1 37.89 97.6898 29.43 83.3698 29.09C69.0498 28.74 57.2398 36.65 56.9998 46.75Z",
    fill: "#131431"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2997 46.75C57.0597 56.73 68.3397 65.09 82.4997 65.43C96.6497 65.77 108.32 57.95 108.56 47.97C108.8 38 97.5197 29.63 83.3597 29.3C69.2097 28.96 57.5397 36.77 57.2997 46.75Z",
    fill: "#141432"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 46.76C57.36 56.62 68.51 64.89 82.5 65.22C96.49 65.55 108.02 57.83 108.25 47.97C108.49 38.11 97.34 29.84 83.35 29.51C69.37 29.17 57.84 36.9 57.6 46.76Z",
    fill: "#141533"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9 46.77C57.67 56.51 68.68 64.68 82.5 65.01C96.32 65.34 107.71 57.71 107.95 47.96C108.18 38.22 97.17 30.05 83.34 29.72C69.53 29.39 58.14 37.02 57.9 46.77Z",
    fill: "#141534"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M107.643 47.9516C107.873 38.3226 96.9898 30.2533 83.3359 29.9283C69.682 29.6032 58.4275 37.1455 58.1983 46.7745C57.969 56.4034 68.8519 64.4727 82.5058 64.7978C96.1597 65.1229 107.414 57.5806 107.643 47.9516Z",
    fill: "#151635"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M58.51 46.78C58.28 56.29 69.03 64.26 82.52 64.58C96.01 64.9 107.13 57.45 107.35 47.94C107.58 38.43 96.83 30.46 83.34 30.14C69.85 29.82 58.73 37.27 58.51 46.78Z",
    fill: "#151636"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M58.81 46.79C58.59 56.18 69.2 64.05 82.53 64.37C95.85 64.69 106.83 57.33 107.06 47.94C107.28 38.55 96.67 30.68 83.34 30.36C70.01 30.04 59.03 37.4 58.81 46.79Z",
    fill: "#161637"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M106.752 47.9371C106.974 38.6615 96.4875 30.8871 83.3305 30.5726C70.1735 30.2581 59.3279 37.5224 59.1061 46.798C58.8844 56.0736 69.3704 63.848 82.5274 64.1625C95.6844 64.4771 106.53 57.2127 106.752 47.9371Z",
    fill: "#161738"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4097 46.8C59.1897 55.96 69.5397 63.63 82.5297 63.94C95.5197 64.25 106.23 57.08 106.44 47.92C106.66 38.76 96.3097 31.09 83.3197 30.78C70.3397 30.47 59.6297 37.65 59.4097 46.8Z",
    fill: "#161739"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M59.71 46.81C59.49 55.85 69.71 63.43 82.54 63.73C95.36 64.04 105.93 56.96 106.15 47.92C106.37 38.88 96.15 31.3 83.32 31C70.5 30.69 59.93 37.77 59.71 46.81Z",
    fill: "#17183A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0101 46.82C59.8001 55.74 69.8801 63.22 82.5401 63.52C95.2001 63.82 105.63 56.83 105.84 47.91C106.05 38.99 95.9701 31.51 83.3101 31.21C70.6601 30.91 60.2301 37.9 60.0101 46.82Z",
    fill: "#17183B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M105.542 47.908C105.753 39.1017 95.7991 31.7207 83.3102 31.4222C70.8213 31.1236 60.5263 38.0204 60.3158 46.8267C60.1052 55.633 70.0589 63.014 82.5478 63.3126C95.0367 63.6112 105.332 56.7143 105.542 47.908Z",
    fill: "#18183D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M60.62 46.83C60.41 55.52 70.23 62.8 82.56 63.09C94.88 63.38 105.04 56.58 105.25 47.89C105.46 39.2 95.64 31.92 83.31 31.63C70.98 31.34 60.83 38.14 60.62 46.83Z",
    fill: "#18193E"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M60.92 46.84C60.72 55.41 70.4 62.59 82.56 62.88C94.72 63.17 104.74 56.46 104.94 47.89C105.14 39.32 95.46 32.14 83.3 31.85C71.14 31.56 61.12 38.27 60.92 46.84Z",
    fill: "#18193F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2199 46.85C61.0199 55.3 70.5699 62.39 82.5599 62.67C94.5499 62.96 104.43 56.34 104.63 47.88C104.83 39.43 95.2799 32.34 83.2899 32.06C71.3099 31.77 61.4199 38.39 61.2199 46.85Z",
    fill: "#191A40"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5197 46.85C61.3197 55.19 70.7397 62.17 82.5697 62.45C94.3897 62.73 104.14 56.2 104.34 47.87C104.54 39.53 95.1197 32.55 83.2897 32.27C71.4697 31.99 61.7197 38.52 61.5197 46.85Z",
    fill: "#191A41"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8201 46.86C61.6201 55.08 70.9101 61.97 82.5701 62.24C94.2301 62.52 103.84 56.08 104.03 47.86C104.23 39.64 94.9401 32.75 83.2801 32.48C71.6301 32.21 62.0201 38.64 61.8201 46.86Z",
    fill: "#1A1A42"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M103.733 47.8647C103.926 39.7651 94.769 32.9765 83.2794 32.7018C71.7898 32.4271 62.3187 38.7704 62.125 46.87C61.9314 54.9696 71.0886 61.7583 82.5782 62.033C94.0678 62.3077 103.539 55.9643 103.733 47.8647Z",
    fill: "#1A1B43"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4297 46.87C62.2397 54.85 71.2597 61.54 82.5897 61.81C93.9097 62.08 103.25 55.83 103.44 47.84C103.63 39.85 94.5997 33.18 83.2697 32.91C71.9497 32.64 62.6197 38.89 62.4297 46.87Z",
    fill: "#1A1B44"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M103.133 47.8504C103.321 39.9827 94.4277 33.3884 83.2694 33.1216C72.111 32.8549 62.9129 39.0166 62.7249 46.8843C62.5368 54.752 71.4299 61.3463 82.5882 61.6131C93.7465 61.8798 102.945 55.7181 103.133 47.8504Z",
    fill: "#1B1C45"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0301 46.89C62.8501 54.64 71.6001 61.13 82.6001 61.39C93.5901 61.65 102.65 55.58 102.83 47.84C103.01 40.09 94.2601 33.6 83.2601 33.34C72.2701 33.07 63.2101 39.14 63.0301 46.89Z",
    fill: "#1B1C46"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3299 46.9C63.1499 54.53 71.7699 60.93 82.5999 61.18C93.4199 61.44 102.35 55.46 102.53 47.83C102.71 40.2 94.0899 33.8 83.2599 33.55C72.4399 33.29 63.5099 39.27 63.3299 46.9Z",
    fill: "#1C1D47"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6298 46.9C63.4498 54.41 71.9498 60.71 82.5998 60.96C93.2598 61.21 102.04 55.33 102.22 47.82C102.4 40.31 93.8998 34.01 83.2498 33.76C72.5998 33.51 63.8098 39.39 63.6298 46.9Z",
    fill: "#1C1D48"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9296 46.91C63.7496 54.31 72.1196 60.5 82.6096 60.76C93.0996 61.01 101.75 55.22 101.93 47.82C102.11 40.42 93.7396 34.23 83.2496 33.98C72.7596 33.73 64.1096 39.51 63.9296 46.91Z",
    fill: "#1C1D49"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2399 46.92C64.0699 54.2 72.2999 60.3 82.6199 60.55C92.9399 60.8 101.45 55.1 101.63 47.82C101.8 40.54 93.5699 34.44 83.2499 34.19C72.9199 33.94 64.4099 39.64 64.2399 46.92Z",
    fill: "#1D1E4A"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5397 46.93C64.3697 54.09 72.4697 60.09 82.6197 60.34C92.7797 60.58 101.15 54.97 101.32 47.81C101.49 40.65 93.3897 34.65 83.2397 34.4C73.0797 34.16 64.7097 39.76 64.5397 46.93Z",
    fill: "#1D1E4B"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M101.015 47.7938C101.183 40.7488 93.2178 34.8448 83.2244 34.6069C73.2311 34.3689 64.9939 39.8872 64.8261 46.9323C64.6584 53.9773 72.6237 59.8813 82.617 60.1192C92.6104 60.3571 100.848 54.8389 101.015 47.7938Z",
    fill: "#1E1F4C"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1399 46.94C64.9699 53.87 72.8099 59.67 82.6299 59.91C92.4499 60.14 100.55 54.72 100.72 47.79C100.89 40.86 93.0499 35.06 83.2299 34.82C73.3999 34.59 65.3099 40.01 65.1399 46.94Z",
    fill: "#1E1F4D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4399 46.95C65.2799 53.76 72.9799 59.47 82.6299 59.7C92.2899 59.93 100.25 54.6 100.41 47.79C100.57 40.98 92.8699 35.27 83.2199 35.04C73.5699 34.8 65.5999 40.14 65.4399 46.95Z",
    fill: "#1E1F4E"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7398 46.95C65.5798 53.64 73.1498 59.25 82.6398 59.48C92.1298 59.71 99.9598 54.47 100.12 47.77C100.28 41.08 92.7098 35.47 83.2198 35.24C73.7298 35.02 65.8998 40.26 65.7398 46.95Z",
    fill: "#1F204F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0499 46.96C65.8899 53.53 73.3299 59.04 82.6499 59.27C91.9799 59.49 99.6599 54.34 99.8199 47.77C99.9799 41.2 92.5399 35.69 83.2199 35.46C73.8899 35.24 66.1999 40.39 66.0499 46.96Z",
    fill: "#1F2050"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5064 47.7581C99.66 41.3038 92.3592 35.8948 83.1996 35.6767C74.0399 35.4587 66.49 40.5141 66.3363 46.9684C66.1827 53.4227 73.4835 58.8317 82.6431 59.0497C91.8028 59.2678 99.3527 54.2123 99.5064 47.7581Z",
    fill: "#202151"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6498 46.98C66.4998 53.32 73.6698 58.63 82.6598 58.85C91.6498 59.06 99.0598 54.1 99.2198 47.76C99.3698 41.42 92.1998 36.11 83.2098 35.89C74.2098 35.67 66.7998 40.64 66.6498 46.98Z",
    fill: "#202152"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9496 46.98C66.7996 53.2 73.8396 58.42 82.6596 58.63C91.4896 58.84 98.7596 53.97 98.9096 47.75C99.0596 41.53 92.0196 36.31 83.1996 36.1C74.3696 35.89 67.0996 40.76 66.9496 46.98Z",
    fill: "#202253"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M67.25 46.99C67.1 53.09 74.01 58.21 82.67 58.42C91.33 58.63 98.47 53.85 98.61 47.74C98.76 41.64 91.85 36.52 83.19 36.31C74.53 36.1 67.4 40.89 67.25 46.99Z",
    fill: "#212254"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M67.55 47C67.41 52.98 74.18 58 82.67 58.21C91.16 58.41 98.16 53.72 98.31 47.74C98.45 41.75 91.68 36.73 83.19 36.53C74.7 36.32 67.7 41.01 67.55 47Z",
    fill: "#212255"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8498 47C67.7098 52.87 74.3498 57.79 82.6698 57.99C90.9998 58.19 97.8598 53.59 97.9998 47.72C98.1398 41.85 91.4998 36.93 83.1798 36.73C74.8598 36.54 67.9898 41.13 67.8498 47Z",
    fill: "#222356"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1599 47.01C68.0199 52.76 74.5299 57.58 82.6899 57.78C90.8499 57.97 97.5799 53.47 97.7099 47.72C97.8499 41.97 91.3399 37.15 83.1799 36.95C75.0199 36.75 68.2899 41.26 68.1599 47.01Z",
    fill: "#222358"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M68.46 47.02C68.33 52.65 74.7 57.38 82.69 57.57C90.68 57.76 97.27 53.35 97.41 47.71C97.54 42.07 91.17 37.35 83.18 37.16C75.18 36.97 68.59 41.38 68.46 47.02Z",
    fill: "#222459"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7598 47.03C68.6298 52.55 74.8698 57.17 82.6898 57.36C90.5198 57.55 96.9698 53.22 97.0998 47.71C97.2298 42.19 90.9898 37.57 83.1698 37.38C75.3398 37.19 68.8898 41.51 68.7598 47.03Z",
    fill: "#23245A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0597 47.03C68.9297 52.43 75.0397 56.96 82.6997 57.14C90.3597 57.32 96.6697 53.09 96.7997 47.69C96.9297 42.29 90.8197 37.76 83.1597 37.58C75.4997 37.4 69.1897 41.63 69.0597 47.03Z",
    fill: "#23255B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M69.36 47.04C69.23 52.32 75.21 56.75 82.7 56.93C90.19 57.11 96.37 52.97 96.5 47.69C96.63 42.41 90.65 37.98 83.16 37.8C75.66 37.62 69.49 41.76 69.36 47.04Z",
    fill: "#24255C"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M69.66 47.05C69.54 52.22 75.38 56.54 82.7 56.72C90.03 56.89 96.07 52.85 96.19 47.68C96.31 42.51 90.47 38.19 83.15 38.01C75.83 37.84 69.79 41.88 69.66 47.05Z",
    fill: "#24255D"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9599 47.05C69.8399 52.1 75.5499 56.33 82.7099 56.5C89.8699 56.67 95.7699 52.72 95.8899 47.67C96.0099 42.62 90.2999 38.39 83.1399 38.22C75.9899 38.05 70.0899 42.01 69.9599 47.05Z",
    fill: "#24265E"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M70.27 47.06C70.15 51.99 75.73 56.12 82.72 56.29C89.71 56.46 95.48 52.6 95.6 47.66C95.72 42.73 90.14 38.6 83.15 38.43C76.15 38.27 70.38 42.13 70.27 47.06Z",
    fill: "#25265F"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M70.57 47.07C70.46 51.88 75.9 55.92 82.72 56.08C89.55 56.24 95.18 52.47 95.29 47.66C95.4 42.85 89.96 38.81 83.14 38.65C76.31 38.49 70.68 42.26 70.57 47.07Z",
    fill: "#252760"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8698 47.08C70.7598 51.78 76.0698 55.71 82.7298 55.87C89.3898 56.03 94.8798 52.35 94.9898 47.66C95.0998 42.96 89.7898 39.03 83.1298 38.87C76.4698 38.7 70.9798 42.38 70.8698 47.08Z",
    fill: "#262761"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1697 47.08C71.0597 51.66 76.2397 55.5 82.7297 55.65C89.2197 55.8 94.5797 52.22 94.6897 47.64C94.7997 43.06 89.6197 39.22 83.1297 39.07C76.6297 38.92 71.2797 42.51 71.1697 47.08Z",
    fill: "#262862"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M71.47 47.09C71.36 51.55 76.41 55.29 82.73 55.44C89.06 55.59 94.27 52.1 94.38 47.64C94.49 43.18 89.44 39.44 83.12 39.29C76.79 39.14 71.58 42.63 71.47 47.09Z",
    fill: "#272863"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7701 47.1C71.6701 51.44 76.5801 55.08 82.7401 55.23C88.9001 55.38 93.9801 51.97 94.0801 47.63C94.1801 43.29 89.2701 39.65 83.1101 39.5C76.9601 39.35 71.8801 42.75 71.7701 47.1Z",
    fill: "#272864"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0797 47.11C71.9797 51.34 76.7597 54.88 82.7497 55.02C88.7397 55.16 93.6897 51.85 93.7897 47.63C93.8897 43.4 89.1097 39.86 83.1197 39.72C77.1197 39.57 72.1797 42.88 72.0797 47.11Z",
    fill: "#272965"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M72.38 47.11C72.28 51.22 76.93 54.66 82.76 54.8C88.59 54.94 93.39 51.72 93.49 47.61C93.59 43.5 88.94 40.06 83.11 39.92C77.28 39.79 72.47 43 72.38 47.11Z",
    fill: "#282966"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6799 47.12C72.5799 51.11 77.0999 54.46 82.7599 54.59C88.4199 54.73 93.0898 51.6 93.1798 47.61C93.2798 43.62 88.7598 40.27 83.0998 40.14C77.4398 40 72.7699 43.13 72.6799 47.12Z",
    fill: "#282A67"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9799 47.13C72.8899 51 77.2699 54.25 82.7599 54.38C88.2599 54.51 92.7899 51.48 92.8799 47.6C92.9699 43.73 88.5899 40.48 83.0999 40.35C77.5999 40.22 73.0699 43.25 72.9799 47.13Z",
    fill: "#292A68"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2797 47.13C73.1897 50.89 77.4397 54.04 82.7697 54.16C88.0997 54.29 92.4897 51.34 92.5797 47.59C92.6697 43.83 88.4197 40.68 83.0897 40.56C77.7597 40.43 73.3697 43.38 73.2797 47.13Z",
    fill: "#292B6A"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5801 47.14C73.4901 50.78 77.6101 53.83 82.7701 53.95C87.9301 54.07 92.1901 51.22 92.2701 47.58C92.3601 43.94 88.2401 40.89 83.0801 40.77C77.9301 40.65 73.6701 43.5 73.5801 47.14Z",
    fill: "#292B6B"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8796 47.15C73.7996 50.67 77.7796 53.62 82.7696 53.74C87.7696 53.86 91.8796 51.1 91.9696 47.58C92.0496 44.06 88.0696 41.11 83.0796 40.99C78.0896 40.87 73.9696 43.63 73.8796 47.15Z",
    fill: "#2A2B6C"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1897 47.16C74.1097 50.56 77.9597 53.42 82.7897 53.53C87.6197 53.65 91.5997 50.98 91.6797 47.57C91.7597 44.17 87.9097 41.31 83.0797 41.2C78.2497 41.08 74.2697 43.75 74.1897 47.16Z",
    fill: "#2A2C6D"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M74.49 47.16C74.41 50.45 78.13 53.2 82.79 53.31C87.45 53.42 91.3 50.85 91.37 47.56C91.45 44.27 87.73 41.52 83.07 41.41C78.41 41.3 74.57 43.88 74.49 47.16Z",
    fill: "#2B2C6E"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7899 47.17C74.7099 50.34 78.2999 53 82.7899 53.1C87.2899 53.21 90.9899 50.72 91.0699 47.55C91.1499 44.38 87.5599 41.72 83.0699 41.62C78.5699 41.52 74.8599 44 74.7899 47.17Z",
    fill: "#2B2D6F"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0899 47.18C75.0199 50.23 78.4699 52.79 82.7999 52.89C87.1299 52.99 90.6999 50.6 90.7699 47.55C90.8399 44.5 87.3899 41.94 83.0599 41.84C78.7299 41.73 75.1599 44.12 75.0899 47.18Z",
    fill: "#2B2D70"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3898 47.18C75.3198 50.11 78.6398 52.57 82.7998 52.67C86.9598 52.77 90.3898 50.47 90.4598 47.54C90.5298 44.61 87.2098 42.15 83.0498 42.05C78.8898 41.95 75.4598 44.25 75.3898 47.18Z",
    fill: "#2C2E71"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6896 47.19C75.6196 50.01 78.8096 52.37 82.7996 52.46C86.7996 52.56 90.0896 50.35 90.1596 47.53C90.2296 44.71 87.0396 42.35 83.0496 42.26C79.0596 42.17 75.7596 44.37 75.6896 47.19Z",
    fill: "#2C2E72"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9999 47.2C75.9399 49.9 78.9899 52.16 82.8199 52.25C86.6499 52.34 89.8099 50.23 89.8699 47.53C89.9299 44.83 86.8799 42.57 83.0499 42.48C79.2199 42.38 76.0599 44.5 75.9999 47.2Z",
    fill: "#2D2E73"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2997 47.21C76.2397 49.79 79.1597 51.96 82.8197 52.04C86.4797 52.13 89.4997 50.1 89.5597 47.52C89.6197 44.94 86.6997 42.77 83.0397 42.69C79.3797 42.6 76.3597 44.62 76.2997 47.21Z",
    fill: "#2D2F74"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5996 47.21C76.5396 49.68 79.3296 51.74 82.8296 51.82C86.3296 51.9 89.2096 49.97 89.2696 47.51C89.3296 45.04 86.5396 42.98 83.0396 42.9C79.5396 42.82 76.6596 44.75 76.5996 47.21Z",
    fill: "#2E2F75"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8999 47.22C76.8399 49.57 79.4999 51.54 82.8299 51.62C86.1599 51.7 88.9099 49.86 88.9599 47.51C89.0199 45.16 86.3599 43.19 83.0299 43.11C79.6999 43.03 76.9599 44.87 76.8999 47.22Z",
    fill: "#2E3076"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2 47.23C77.15 49.46 79.67 51.33 82.83 51.41C85.99 51.49 88.6 49.74 88.66 47.51C88.71 45.28 86.19 43.41 83.03 43.33C79.86 43.25 77.25 45 77.2 47.23Z",
    fill: "#2E3077"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4998 47.23C77.4498 49.34 79.8398 51.11 82.8398 51.19C85.8398 51.26 88.3098 49.61 88.3598 47.49C88.4098 45.38 86.0198 43.61 83.0198 43.53C80.0198 43.47 77.5498 45.12 77.4998 47.23Z",
    fill: "#2F3179"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7996 47.24C77.7496 49.24 80.0096 50.91 82.8396 50.98C85.6696 51.05 87.9996 49.48 88.0496 47.49C88.0996 45.49 85.8396 43.82 83.0096 43.75C80.1796 43.68 77.8496 45.25 77.7996 47.24Z",
    fill: "#2F317A"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1099 47.25C78.0699 49.13 80.1899 50.7 82.8499 50.77C85.5099 50.83 87.7099 49.36 87.7599 47.48C87.7999 45.6 85.6799 44.03 83.0199 43.96C80.3499 43.9 78.1499 45.37 78.1099 47.25Z",
    fill: "#30317B"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4098 47.26C78.3698 49.02 80.3598 50.5 82.8598 50.56C85.3598 50.62 87.4198 49.24 87.4598 47.48C87.4998 45.72 85.5098 44.24 83.0098 44.18C80.5098 44.12 78.4498 45.5 78.4098 47.26Z",
    fill: "#30327C"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7096 47.26C78.6696 48.9 80.5296 50.28 82.8596 50.34C85.1896 50.4 87.1096 49.11 87.1496 47.46C87.1896 45.82 85.3296 44.44 82.9996 44.38C80.6696 44.33 78.7496 45.62 78.7096 47.26Z",
    fill: "#31327D"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M79.01 47.27C78.97 48.8 80.7 50.08 82.86 50.13C85.02 50.18 86.81 48.99 86.85 47.46C86.89 45.93 85.16 44.65 83 44.6C80.83 44.55 79.05 45.74 79.01 47.27Z",
    fill: "#31337E"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M79.31 47.28C79.28 48.69 80.87 49.87 82.87 49.92C84.87 49.97 86.52 48.86 86.55 47.46C86.58 46.05 84.99 44.87 82.99 44.82C80.99 44.77 79.35 45.87 79.31 47.28Z",
    fill: "#31337F"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6098 47.28C79.5798 48.57 81.0398 49.65 82.8698 49.7C84.6998 49.74 86.2098 48.73 86.2398 47.44C86.2698 46.15 84.8098 45.07 82.9798 45.02C81.1498 44.98 79.6398 45.99 79.6098 47.28Z",
    fill: "#323480"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9097 47.29C79.8797 48.46 81.2097 49.45 82.8697 49.49C84.5397 49.53 85.9097 48.61 85.9397 47.44C85.9697 46.27 84.6397 45.28 82.9797 45.24C81.3197 45.2 79.9397 46.12 79.9097 47.29Z",
    fill: "#323481"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2198 47.3C80.1898 48.36 81.3898 49.24 82.8898 49.28C84.3898 49.32 85.6198 48.49 85.6498 47.43C85.6798 46.37 84.4798 45.49 82.9798 45.45C81.4798 45.42 80.2398 46.24 80.2198 47.3Z",
    fill: "#333482"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5198 47.31C80.4998 48.25 81.5598 49.04 82.8898 49.07C84.2198 49.1 85.3198 48.37 85.3398 47.43C85.3598 46.49 84.2998 45.7 82.9698 45.67C81.6398 45.63 80.5398 46.37 80.5198 47.31Z",
    fill: "#333583"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8197 47.31C80.7997 48.13 81.7297 48.82 82.8997 48.85C84.0697 48.88 85.0297 48.23 85.0497 47.41C85.0697 46.59 84.1397 45.9 82.9797 45.87C81.7997 45.85 80.8397 46.49 80.8197 47.31Z",
    fill: "#333584"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M81.12 47.32C81.1 48.02 81.9 48.61 82.9 48.64C83.9 48.66 84.72 48.11 84.74 47.41C84.76 46.71 83.96 46.12 82.96 46.09C81.96 46.06 81.14 46.62 81.12 47.32Z",
    fill: "#343686"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M81.42 47.33C81.41 47.92 82.07 48.41 82.9 48.43C83.73 48.45 84.42 47.99 84.43 47.4C84.44 46.81 83.78 46.32 82.95 46.3C82.12 46.28 81.44 46.74 81.42 47.33Z",
    fill: "#343687"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7199 47.34C81.7099 47.81 82.2399 48.2 82.9099 48.22C83.5799 48.24 84.1299 47.87 84.1399 47.4C84.1499 46.93 83.6199 46.54 82.9499 46.52C82.2799 46.5 81.7399 46.87 81.7199 47.34Z",
    fill: "#353788"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M82.03 47.34C82.02 47.69 82.42 47.99 82.92 48C83.42 48.01 83.83 47.74 83.84 47.38C83.85 47.03 83.45 46.73 82.95 46.72C82.45 46.71 82.03 46.99 82.03 47.34Z",
    fill: "#353789"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3299 47.35C82.3199 47.58 82.5899 47.78 82.9199 47.79C83.2499 47.8 83.5299 47.61 83.5299 47.38C83.5399 47.15 83.2699 46.95 82.9399 46.94C82.6099 46.93 82.3299 47.12 82.3299 47.35Z",
    fill: "#36388A"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6299 47.36C82.6299 47.48 82.7599 47.58 82.9299 47.58C83.0999 47.58 83.2299 47.49 83.2399 47.37C83.2499 47.25 83.1099 47.15 82.9399 47.15C82.7699 47.15 82.6299 47.24 82.6299 47.36Z",
    fill: "#36388B"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M210.82 202.11C216.45 202.11 222.37 200.56 228.62 196.46C242.74 187.19 243.07 167.94 235.28 155.42C227.34 142.66 208.96 133.13 183.28 148.25C142.08 172.52 128.34 160.08 128.21 159.95L123.19 164.77C123.87 165.47 140.25 181.68 186.81 154.25C208.14 141.69 222.78 148.52 229.37 159.1C235.44 168.85 235.41 183.68 224.8 190.65C211.46 199.41 200.54 193.9 187.91 187.52C182.86 184.97 177.63 182.33 172.18 180.7C152.46 174.8 138.17 185.07 137.57 185.51L141.68 191.12C142.17 190.77 153.88 182.49 170.18 187.37C175.05 188.83 179.77 191.21 184.77 193.74C192.74 197.75 201.38 202.11 210.82 202.11Z",
    fill: "#CAB3DA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.89 239C176.89 239 186.67 250.62 195.85 246.92L176.89 239Z",
    fill: "#CAB3DA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7901 133.92C37.0701 142.79 57.2901 153.61 68.5901 152.01C69.1001 151.94 69.6001 151.83 70.0801 151.71C76.8701 149.91 81.8501 142.91 84.4801 138.27C85.8801 135.82 86.6101 134.03 86.6101 134.03L86.9601 111.51C86.9601 111.51 86.6701 111.57 86.1601 111.7C84.5901 112.1 80.9601 113.13 77.5101 115.01C72.9501 117.49 57.3201 120.66 49.2301 118.85C41.1301 117.04 38.2401 114.46 36.2801 114.73C34.3201 115 32.8001 118.3 32.8001 118.3C32.8001 118.3 30.3301 124.57 33.7901 133.92Z",
    fill: "url(#paint1_radial_26_2)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7997 118.29C32.7997 118.29 36.2197 117.03 37.5697 119.15C38.9297 121.28 40.7397 134.2 33.7797 133.92C26.8297 133.64 32.7997 118.29 32.7997 118.29Z",
    fill: "#684D73"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5701 119.06C34.5701 119.06 35.6601 125.98 31.7001 131.83C31.7001 131.83 28.3201 123.32 34.5701 119.06Z",
    fill: "#53345F"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3299 118.5C20.5099 123.09 24.1599 126.11 27.2099 127.97C30.1399 129.77 32.5199 130.48 32.5199 130.48C32.5199 130.48 35.2499 126.74 34.7099 121.78C34.7099 121.78 34.3499 120.94 33.7499 119.7C32.4199 116.97 29.9299 112.33 27.7099 110.74L27.5499 113.93C27.5499 113.93 24.9599 109.41 17.9799 109.7C17.9699 109.72 14.5699 110.59 18.3299 118.5Z",
    fill: "#FF6B22"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1098 119.27C58.1098 119.27 62.1298 125.01 62.5798 137.02C63.0298 149.03 54.8198 149.84 54.8198 149.84C54.8198 149.84 59.6398 151.75 63.1298 151.96C63.1298 151.96 82.6198 147.13 65.6298 118.37L58.1098 119.27Z",
    fill: "#FF6B22"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4799 138.27C84.7699 140.03 85.1298 141.86 85.5898 143.78L92.4799 131.51L88.2898 111.37L86.2598 111.48C86.2298 111.55 86.1998 111.62 86.1698 111.69C84.5998 112.09 80.9698 113.12 77.5198 115C77.5198 115 92.6398 129.86 70.1098 151.69C70.0998 151.69 70.0998 151.69 70.0898 151.71C76.8698 149.91 81.8499 142.91 84.4799 138.27Z",
    fill: "url(#paint2_linear_26_2)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5698 246.21C94.5698 246.21 98.5098 238.89 117.33 240.76C117.33 240.76 109.95 249.97 94.5698 246.21Z",
    fill: "#311745"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.29 219.31C181.29 219.31 169.18 219.29 162.95 232.95C162.95 232.95 168.2 235.12 174.77 231.26C181.35 227.4 181.29 219.31 181.29 219.31Z",
    fill: "#311745"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.93 250.67L116.68 247.43C116.68 247.43 116.54 245.17 116.45 241.57C116.21 232.47 116.23 214.88 119.29 203.99V203.98L87.2602 184.4C87.2602 184.4 87.1202 186.55 86.9402 189.95C86.4502 199.81 82.8202 219.69 84.9802 227.57C87.8602 238.15 107.93 250.67 107.93 250.67Z",
    fill: "url(#paint3_radial_26_2)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2599 184.4C87.2599 184.4 98.0499 198.92 117.81 204.18L119.29 204L127.19 203C127.19 203 127.19 202.98 127.19 202.93C127.19 202.89 127.19 202.86 127.19 202.8C127.19 202.76 127.19 202.73 127.19 202.68C127.18 202.63 127.19 202.58 127.19 202.52C127.25 199.01 128.34 176.97 144.44 157.58C144.44 157.58 142.97 156.01 139.89 151.52C139.62 151.1 139.32 150.66 139 150.2C137.58 148.06 135.88 145.37 133.88 142.04C129.51 134.75 122.17 122.87 117.11 114.7V114.69C115.59 112.24 114.27 110.12 113.3 108.56C112.94 107.97 112.61 107.45 112.35 107.04C111.83 106.19 111.54 105.74 111.54 105.74C111.54 105.74 95.4499 113.52 86.6099 110.62C86.6099 110.62 86.47 110.91 86.23 111.49C86.2 111.56 86.1699 111.63 86.1399 111.7C84.9599 114.74 82.1199 124.02 84.4499 138.28C84.7399 140.04 85.0999 141.87 85.5599 143.79C85.7199 144.46 85.8899 145.15 86.0799 145.85C86.0799 145.85 83.4799 161.84 86.2099 179.07C86.5199 180.84 86.8599 182.62 87.2599 184.4Z",
    fill: "#CAB3DA"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.81 128.73C116.81 128.74 116.81 128.74 116.82 128.75C117.12 129.28 117.45 129.81 117.79 130.36C123.08 138.96 131.27 147.37 139.9 151.51C145.19 154.05 150.64 154.98 155.69 153.38C166.96 149.79 171.76 140.45 172.95 137.71C172.99 137.61 173.03 137.52 173.06 137.45C173.09 137.36 173.12 137.28 173.15 137.23C173.23 137.05 173.26 136.95 173.26 136.95C173.26 136.95 176.91 134.46 175.48 130.3C174.06 126.13 170.27 120.23 170.27 120.23L168.06 120.13C168.06 120.13 166.68 117.34 163.66 117.42C160.63 117.51 154.13 120.15 144.81 118.11C136.62 116.33 124.33 111.37 120.19 109.21C119.61 108.91 119.19 108.66 118.97 108.48C117.14 107.02 114.47 106.38 114.47 106.38L113.21 106.78L112.38 107.04L109.82 107.84C109.81 107.83 108.24 114.18 116.81 128.73Z",
    fill: "url(#paint4_radial_26_2)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.19 202.99C127.19 202.99 145.1 218.65 149.41 222.88C153.71 227.11 166.33 233.41 172.84 234.32C173.01 234.34 173.17 234.37 173.32 234.37C179.48 235.01 182.01 230.93 182.01 230.93C182.01 230.93 181.85 229.69 181.58 227.72C181.22 225.12 180.67 221.25 180.03 217.4C179.19 212.27 178.2 207.17 177.34 205.12C175.87 201.61 158.62 177.33 149.71 164.88C146.55 160.49 144.45 157.56 144.45 157.56C127.05 170.74 127.08 198.56 127.2 202.5C127.2 202.56 127.19 202.61 127.2 202.66C127.19 202.71 127.2 202.75 127.2 202.78C127.2 202.84 127.2 202.88 127.2 202.91C127.2 202.97 127.19 202.99 127.19 202.99Z",
    fill: "url(#paint5_radial_26_2)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.39 108.21C108.39 108.21 100.25 114.37 96.9601 115.35C93.6701 116.34 86.6401 110.6 86.6401 110.6C86.6401 110.6 94.3601 111.62 108.39 108.21Z",
    fill: "#53345F"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.47 106.38C114.47 106.38 114.33 132.95 135.4 149.47C135.4 149.47 116.27 137.9 108.39 108.21L114.47 106.38Z",
    fill: "#53345F"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2799 111.36C88.2799 111.36 84.55 131.35 86.11 145.84C86.11 145.84 80.47 129.78 84.16 112.26L86.6399 110.61L88.2799 111.36Z",
    fill: "#53345F"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.67 162.06C147.67 162.06 135.62 170.74 130.08 205.53L127.19 203C127.19 203 125.43 169.21 144.44 157.58L147.67 162.06Z",
    fill: "#53345F"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.25 179.1C86.25 179.1 101.64 200.62 119.29 204L118.75 206.12C118.75 206.12 100.69 205.18 87.03 188.37L86.25 179.1Z",
    fill: "#53345F"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.26 136.94C173.26 136.94 176.91 134.45 175.48 130.29C174.06 126.12 170.27 120.22 170.27 120.22L168.06 120.12C168.07 120.12 160.7 130.5 173.26 136.94Z",
    fill: "#684D73"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.34 133.23C174.34 133.23 167.08 126.43 170.27 120.22C170.27 120.22 177.07 130.46 174.34 133.23Z",
    fill: "#53345F"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.66 124.79C169.66 124.79 169.26 118.77 174.03 115.78L175 118.39C175 118.39 180.86 111.76 187.27 114.58C187.27 114.58 188.13 126.55 173.32 132.24C173.31 132.24 170.36 129.7 169.66 124.79Z",
    fill: "#FF6B22"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M172.32 197.1C172.32 197.1 175.21 205.23 165.11 213.42C155 221.61 145.49 219.22 145.49 219.22C145.49 219.22 150.22 224.04 153.51 226.03C156.8 228.01 173.43 221.44 178.88 210.97C178.88 210.97 178.26 206.5 176.91 204.26C175.55 202.01 172.32 197.1 172.32 197.1Z",
    fill: "#FF6B22"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M117.05 217.54C117.05 217.54 110.45 224.88 102.03 228.91C93.6099 232.94 85.8999 230.21 85.8999 230.21C85.8999 230.21 88.8899 235.64 92.5299 238.57C92.5299 238.57 102.74 237.89 107.97 234.59C113.2 231.28 116.55 225.37 116.55 225.37L117.05 217.54Z",
    fill: "#FF6B22"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M142.39 117.51C142.39 117.51 128.48 136.47 148.19 154.03C148.19 154.03 144.17 153.74 140.46 151.77C134.77 149.06 119.87 123.73 135.9 115.45L142.39 117.51Z",
    fill: "#FF6B22"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M119.06 204.18L119.5 203.8C119.37 203.65 106.63 188.55 102.17 176.48C98.31 166.03 97.96 160.32 97.48 152.42C97.3 149.43 97.09 146.04 96.66 142.01C95.13 127.86 95.76 116.04 95.77 115.92L95.19 115.89C95.18 116.01 94.54 127.87 96.08 142.08C96.52 146.09 96.72 149.48 96.9 152.46C97.38 160.41 97.73 166.16 101.62 176.69C106.13 188.85 118.94 204.03 119.06 204.18Z",
    fill: "#53345F"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.74 241.83L116.45 241.57C116.21 232.47 116.23 214.88 119.29 203.99L127.19 202.99C127.19 202.99 145.1 218.65 149.41 222.88C153.71 227.11 166.33 233.41 172.84 234.32C173.01 234.34 173.17 234.37 173.32 234.37L181.58 227.72C181.22 225.12 180.67 221.25 180.03 217.4L179.27 217.2C179.27 217.2 170.76 227.45 160.72 226.87C150.68 226.29 133.69 202.9 133.91 198.57C134.73 182.41 144.37 170.37 149.72 164.88C146.56 160.49 144.46 157.56 144.46 157.56C144.46 157.56 142.99 155.99 139.91 151.5C145.2 154.04 150.65 154.97 155.7 153.37C166.97 149.78 171.77 140.44 172.96 137.7C171.61 140.6 165.59 151.19 148.86 152.35C145.31 152.6 142.02 151.76 139.02 150.18C125.63 143.15 117.9 121.45 117.23 116.8C117.12 116.02 117.09 115.32 117.13 114.68V114.67C117.39 110.63 120.19 109.2 120.19 109.2C119.61 108.9 119.19 108.65 118.97 108.47C117.14 107.01 114.47 106.37 114.47 106.37L113.21 106.77C113.24 107.22 113.27 107.82 113.33 108.55C113.63 112.56 114.49 120.48 116.83 128.73C116.83 128.74 116.83 128.74 116.84 128.75C118.27 133.82 120.27 139.02 123.03 143.53C132.24 158.51 135.22 160.99 135.22 160.99C135.22 160.99 128.37 185.96 121.61 192.16C114.84 198.35 95.8798 188.72 91.0798 183.92C88.7898 181.64 87.2598 180.08 86.2598 179.07C86.5398 180.85 86.8798 182.63 87.2798 184.41C87.2798 184.41 87.1398 186.56 86.9598 189.96C91.7198 195.04 107.94 212.64 111.04 219.78C114.65 228.16 115.74 241.83 115.74 241.83Z",
    fill: "url(#paint6_linear_26_2)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.47 106.37C114.47 106.37 111.03 120.84 97.76 129.55C84.49 138.26 80.29 113.62 80.29 113.62L84.16 112.26L86.26 111.48L114.47 106.37Z",
    fill: "#53345F"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3001 94.38C45.4001 94.54 45.4801 94.7 45.5901 94.86C46.9701 96.99 49.5101 99.32 52.8601 101.5C52.8601 101.5 53.0501 101.64 53.4301 101.86C59.6401 105.8 68.4401 109.21 77.6501 110.16C92.5901 111.69 114.58 109.47 128.42 98.93C142.25 88.39 146.77 58.65 142.59 49.36C141.48 46.87 139.89 43.57 137.72 39.98C131.83 30.2 121.65 18.32 105.01 15C92.4401 12.49 75.6901 14.59 63.0301 18.76C59.0801 20.06 55.5401 21.57 52.6401 23.2C50.6701 24.31 49.0001 25.47 47.7001 26.67L47.1701 27.19C46.8001 27.55 46.4801 27.93 46.1901 28.29C30.6101 48.42 38.8001 82.99 45.3001 94.38Z",
    fill: "url(#paint7_linear_26_2)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3399 92.15C47.4299 92.3 47.5099 92.45 47.6199 92.6C50.8999 95.81 62.1999 104.16 80.9899 99.65C104.11 94.1 107.01 74.13 107.01 74.13L111.52 73.34C111.4 70.4 111.41 67.7 111.53 65.23C112.16 51.37 115.95 44.66 115.8 42.66C115.62 40.3 110.01 27.07 93.1499 21.71C81.9799 18.16 71.4399 19.33 63.9599 21.24C60.2599 22.46 56.9399 23.87 54.2099 25.41C52.3599 26.45 50.7899 27.54 49.5699 28.66L49.0699 29.15C48.7199 29.49 48.4199 29.84 48.1499 30.19C42.0899 38.03 39.8699 48.18 39.7799 58.15C39.6599 72.21 43.7699 85.9 47.3399 92.15Z",
    fill: "url(#paint8_linear_26_2)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4399 101.86C59.6499 105.8 68.4499 109.21 77.6599 110.16C92.5999 111.69 114.59 109.47 128.43 98.93C142.26 88.39 146.78 58.65 142.6 49.36C141.49 46.87 139.9 43.57 137.73 39.98C135.71 38.03 133.21 36.91 130.18 37.53C119.05 39.84 117.24 76.23 117.24 76.23L111.79 75.94C111.79 75.94 108.95 96.87 87.0499 104.47C67.8999 111.13 56.1099 103.4 53.4399 101.86Z",
    fill: "url(#paint9_linear_26_2)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.46 92.36C129.2 97.23 119.44 95.53 117.84 76.98C116.26 58.37 126.24 40.07 126.24 40.07C110.88 42.11 113.73 74.32 113.73 74.32C114.05 75.68 114.38 76.95 114.73 78.14L114.77 78.27C122 103.48 133.46 93.3 134.46 92.36Z",
    fill: "url(#paint10_linear_26_2)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.44 52.01C141.69 45.71 137.64 41.51 134.02 41.7C130.4 41.89 121.12 58.33 123.64 76.65C126.15 94.97 137.68 88.78 139.85 81.75L141.13 77.92C141.13 77.92 132.51 89.72 127.61 78.63C122.02 65.96 132.17 49.36 137.7 51.42C143.22 53.48 143.87 63.87 143.87 63.87C143.87 63.87 144.59 56.19 143.44 52.01Z",
    fill: "#53345F"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.81 249.51L117.41 247.17L117.33 240.77C117.33 240.77 104.12 247.18 94.5601 246.21C94.5601 246.21 99.3001 250.7 106.93 252C106.93 252 99.4601 255.68 99.9901 263.71L118.81 249.51Z",
    fill: "#684D73"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.01 232.95L175.94 236.45L176.88 239C176.88 239 184.65 247.32 195.85 246.91C195.85 246.91 193.89 237.52 183.08 232.99L181.3 219.31C181.3 219.31 179.93 224.74 175.16 229.28C170.6 233.61 163.62 233.02 163.01 232.95Z",
    fill: "#684D73"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.81 249.51L120.14 250.62L100.76 264.94L99.9897 263.7L118.81 249.51Z",
    fill: "#CAB3DA"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5698 246.21C94.5698 246.21 99.3098 250.7 106.94 252C106.94 252 115.15 249.49 118.82 249.51L117.42 247.17L117.34 240.77C117.33 240.77 104.12 247.17 94.5698 246.21Z",
    fill: "url(#paint11_linear_26_2)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.01 232.95L175.94 236.45C180.18 235.58 183.08 232.99 183.08 232.99L181.3 219.31C181.3 219.31 179.93 224.74 175.16 229.28C170.6 233.61 163.62 233.02 163.01 232.95Z",
    fill: "url(#paint12_linear_26_2)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M107.89 42.66C107.89 42.66 107.7 37.19 107.1 35.56C107.1 35.56 103.53 32.57 99.1098 31.43L96.0898 41.17C96.0898 41.17 105.32 41.91 107.89 42.66Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M103.15 77.87C103.15 77.87 102.06 82.56 99.98 85.37L97.25 83.9C97.25 83.9 99.23 79.66 100.09 77.11L103.15 77.87Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.78 123.31C184.78 123.31 180.26 128.3 175.57 128.54C170.87 128.78 169.67 123.94 169.67 123.94C169.67 123.94 169.14 127.9 173.32 132.23C173.31 132.24 181.71 129.19 184.78 123.31Z",
    fill: "url(#paint13_linear_26_2)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.21 127.97C30.14 129.77 32.52 130.48 32.52 130.48C32.52 130.48 35.25 126.74 34.71 121.78C34.71 121.78 34.35 120.94 33.75 119.7C33.74 119.71 33.94 124.76 27.21 127.97Z",
    fill: "url(#paint14_linear_26_2)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.71 136.31C103.13 140.15 107.4 142.12 111.24 140.7C115.08 139.28 117.05 135.01 115.63 131.17C114.21 127.33 109.94 125.36 106.1 126.78C102.25 128.19 100.29 132.46 101.71 136.31Z",
    fill: "#684D73"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.29 135.35C105.18 137.77 107.87 139 110.28 138.11C112.7 137.22 113.93 134.53 113.04 132.12C112.15 129.7 109.46 128.47 107.05 129.36C104.63 130.25 103.4 132.93 104.29 135.35Z",
    fill: "#FF6B22"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.97 114.52C132.97 114.52 126.04 122.34 121.4 109.8C121.4 109.8 129.76 113.33 132.97 114.52Z",
    fill: "#684D73"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M102.59 213.25C110.2 213.25 117.21 212.19 117.75 212.11L117.66 211.54C117.41 211.58 92.4698 215.35 85.2098 208.75L84.8198 209.18C88.3698 212.39 95.7198 213.25 102.59 213.25Z",
    fill: "#53345F"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M136.18 211.75L136.76 211.69C136.75 211.63 136.18 205.39 138 198.3C140.87 187.15 155.55 173.34 155.7 173.2L155.3 172.78C155.15 172.92 140.34 186.84 137.43 198.16C135.59 205.35 136.17 211.69 136.18 211.75Z",
    fill: "#53345F"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M165.62 147.64L166.12 147.35C153.25 125.14 163.72 117.72 163.83 117.65L163.51 117.17C163.39 117.24 152.46 124.93 165.62 147.64Z",
    fill: "#53345F"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6501 146.08C55.9301 132.63 41.9401 116.44 41.7901 116.27L41.3501 116.65C41.4901 116.81 55.1901 132.66 46.1601 145.74L46.6501 146.08Z",
    fill: "#53345F"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M114.29 155.09C114.29 155.09 114.9 156.89 116.73 159.51L119.9 157.95C119.9 157.95 118.95 155.33 116.74 153.92L114.29 155.09Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M156.86 119.93C156.86 119.93 155.03 120.55 153.21 120.16L151.9 121.77C151.9 121.77 154.58 123.32 156.49 121.85L156.86 119.93Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M165.41 198.89C165.41 198.89 167.59 200.58 168.46 202.93L166.31 204.85L163.61 200.75L165.41 198.89Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7998 114.95C36.7998 114.95 38.3598 115.6 39.4398 117.6L41.8398 118.06C41.8398 118.06 41.2298 117.11 40.3498 116.35C39.4698 115.59 36.7998 114.95 36.7998 114.95Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3899 216.08C88.3899 216.08 87.0599 222 87.6499 224.83L85.1199 224.78C85.1199 224.78 84.1199 220.43 85.4799 216.27L88.3899 216.08Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M102.36 21.32C102.36 21.32 88.1598 16.11 79.0898 16.44C79.0898 16.45 111.17 12.12 102.36 21.32Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M120.97 53.04L115.59 51.61L114.3 57.47L119.49 58.39L120.97 53.04Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_26_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.878 47.0362) rotate(-179.12) scale(12.4849 5.6062)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0562,
    stopColor: "#0036D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1982,
    stopColor: "#00289E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#001C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4814,
    stopColor: "#001246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6191,
    stopColor: "#000A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7532,
    stopColor: "#000412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#000104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_26_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.9281 129.617) rotate(159.702) scale(26.1929 26.1929)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4DBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1BDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26_2",
    x1: 93.6503,
    y1: 125.869,
    x2: 64.5096,
    y2: 136.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9579A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_26_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.555 219.073) rotate(159.702) scale(27.9237 27.9237)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1BDE5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_26_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.348 126.331) rotate(159.702) scale(28.5922 28.5922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4DBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1BDE5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_26_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.637 199.643) rotate(159.702) scale(33.6671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1BDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26_2",
    x1: 180.075,
    y1: 156.952,
    x2: 87.4117,
    y2: 191.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9579A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26_2",
    x1: 107.37,
    y1: 108.831,
    x2: 72.7148,
    y2: 15.1349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1BDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_26_2",
    x1: 91.9556,
    y1: 95.9119,
    x2: 64.275,
    y2: 21.0727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F183B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_26_2",
    x1: 147.492,
    y1: 62.5291,
    x2: 51.9601,
    y2: 97.8632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9579A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_26_2",
    x1: 133.191,
    y1: 93.7414,
    x2: 114.802,
    y2: 44.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1BDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DBEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_26_2",
    x1: 118.361,
    y1: 243.54,
    x2: 96.5608,
    y2: 251.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9579A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_26_2",
    x1: 183.795,
    y1: 226.063,
    x2: 163.268,
    y2: 233.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9579A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_26_2",
    x1: 184.734,
    y1: 123.196,
    x2: 170.583,
    y2: 128.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9579A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_26_2",
    x1: 35.5902,
    y1: 124.186,
    x2: 26.9869,
    y2: 127.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9579A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstronautMain);
export default __webpack_public_path__ + "static/media/astronaut_main.247570a135234367030bf4ecb47dcc1f.svg";
export { ForwardRef as ReactComponent };